import { UIGameMapHighlightView } from '../UIGameMapHighlightView.ts';
import { UIGameConfirmActionController } from '../../ui_game_confirmation/UIGameConfirmActionController.ts';
import { GameStateEnums } from '../../../../../../shared/GameEnums.ts';
import { UIUtilsEjsVariables } from '../../../UIUtilsEjsVariables.ts';
import { UIGameBeginnerHintView } from '../../ui_game_beginner_hints/UIGameBeginnerHintView.ts';
import { GameAction } from '@colonist/game-base-types';
import { AudioManager, AudioType } from '@colonist/audio';
import { UIGameSpriteHandler } from '../../../UIGameSpriteHandler.ts';
import { PIXI } from '@colonist/pixi';
import { logError } from '../../../ui_utils/Utils.ts';
import { Sprites } from '../../UIGameImageDictionary.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { TurnState } from '@colonist/game-states';
export class UIGameMapHighlightController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GameEnd:
                this.removeHighlights();
                break;
            case UIGameEventEnums.BeginnerHintReceived:
                this.beginnerHintReceived(data);
                break;
            case UIGameEventEnums.GameStateUpdated:
                this.destroyBeginnerHintView();
                break;
            case UIGameEventEnums.CanvasResized:
                this.onCanvasResize();
                break;
            case UIGameEventEnums.BeginnerModeActionUpdated:
                this.onBeginnerModeActionUpdate(data);
                break;
            default:
                break;
        }
    }
    removeHighlights() {
        for (const view of this.highlightViews){
            this.uiGameManager.mapController.mapView.removeChild(view);
        }
        this.highlightViews = [];
        this.confirmActionController.cleanupConfirmation();
    }
    highlight(highlightParameters, action) {
        const highlightView = new UIGameMapHighlightView(this.uiGameManager, highlightParameters, this.uiGameManager.mapController.mapView, action);
        this.highlightViews.push(highlightView);
    }
    startAnimation() {
        this.animateCircles();
    }
    endAnimation() {
        for (const highlightView of this.highlightViews)highlightView.resetAnimation();
    }
    destroyBeginnerHintView() {
        var _this_beginnerHintView;
        (_this_beginnerHintView = this.beginnerHintView) === null || _this_beginnerHintView === void 0 ? void 0 : _this_beginnerHintView.destroy();
        this.beginnerHintView = undefined;
    }
    hideBeginnerHintInformation() {
        var _this_beginnerHintView;
        (_this_beginnerHintView = this.beginnerHintView) === null || _this_beginnerHintView === void 0 ? void 0 : _this_beginnerHintView.hideInformation();
    }
    isAllowedPlacementIndex(index) {
        var _this_uiGameManager_cardController_beginnerModeHelper, _this_currentBeginnerModeAction;
        if (this.allowedPlacementIndexes == undefined) return true;
        if ((_this_uiGameManager_cardController_beginnerModeHelper = this.uiGameManager.cardController.beginnerModeHelper) === null || _this_uiGameManager_cardController_beginnerModeHelper === void 0 ? void 0 : _this_uiGameManager_cardController_beginnerModeHelper.areCardsBeingDealt) return false;
        if (((_this_currentBeginnerModeAction = this.currentBeginnerModeAction) === null || _this_currentBeginnerModeAction === void 0 ? void 0 : _this_currentBeginnerModeAction.type) == GameAction.SkippedWelcome) this.uiGameManager.socketGameSend.skipWelcomeActionOnBeginnerMode();
        return this.allowedPlacementIndexes.includes(index);
    }
    animateCircles() {
        if (this.highlightViews.length <= 0) this.endAnimation();
        for (const highlightView of this.highlightViews){
            highlightView.animate();
        }
    }
    beginnerHintReceived(data) {
        const possibleMapActionSuggestions = [
            GameAction.ConfirmBuildSettlement,
            GameAction.ConfirmBuildCity,
            GameAction.ConfirmBuildRoad
        ];
        if (!possibleMapActionSuggestions.includes(data.type)) return;
        const targetHighlightIndex = data.data;
        for (const highlight of this.highlightViews){
            if (highlight.parent == undefined) continue;
            if (highlight.highlightedGameElementIndex != targetHighlightIndex) continue;
            if (this.confirmActionController.selectedLocationIndex == targetHighlightIndex) return;
            this.destroyBeginnerHintView();
            AudioManager.play(AudioType.BeginnerHintActivated);
            const descriptionContext = this.getBeginnerTipDescriptionContext(data.type);
            const tipTexture = this.getBeginnerTipTexture(data.type);
            this.beginnerHintView = new UIGameBeginnerHintView(this.uiGameManager, highlight, {
                key: `strings:game.beginnerTips.actionHints.description`,
                options: {
                    context: descriptionContext
                }
            }, tipTexture);
            this.beginnerHint = data;
            highlight.resetDisplay();
        }
    }
    onCanvasResize() {
        if (this.beginnerHintView == undefined) return;
        this.beginnerHintReceived(this.beginnerHint);
    }
    onBeginnerModeActionUpdate(data) {
        this.currentBeginnerModeAction = data;
        this.allowedPlacementIndexes = data.allowedPlacementIndexes;
    }
    removeSelectedIndexHighlights(selectedIndexes) {
        this.highlightViews = this.highlightViews.filter((highlightView)=>{
            const shouldRemove = selectedIndexes.includes(highlightView.highlightedGameElementIndex);
            if (shouldRemove) {
                this.uiGameManager.mapController.mapView.removeChild(highlightView);
            }
            return !shouldRemove;
        });
    }
    getBeginnerTipDescriptionContext(suggestedAction) {
        const isInitialPlacements = this.uiGameManager.gameController.currentState.turnState == TurnState.InitialPlacement;
        switch(suggestedAction){
            case GameAction.ConfirmBuildSettlement:
                return isInitialPlacements ? 'initialPlacementCorner' : 'buildSettlement';
            case GameAction.ConfirmBuildCity:
                return isInitialPlacements ? 'initialPlacementCorner' : 'buildCity';
            case GameAction.ConfirmBuildRoad:
                return 'buildRoad';
            default:
                logError('getDescriptionContext', [
                    'Invalid suggested action',
                    suggestedAction
                ]);
                return '';
        }
    }
    getBeginnerTipTexture(suggestedAction) {
        const isInitialPlacements = this.uiGameManager.gameController.currentState.turnState == TurnState.InitialPlacement;
        const initialPlacementCornerTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_beginner_hint_initial_placement);
        switch(suggestedAction){
            case GameAction.ConfirmBuildSettlement:
                return isInitialPlacements ? initialPlacementCornerTexture : UIGameSpriteHandler.getSettlementForPlayer(this.uiGameManager.gameController.myColor);
            case GameAction.ConfirmBuildCity:
                return UIGameSpriteHandler.getCityForPlayer(this.uiGameManager.gameController.myColor);
            case GameAction.ConfirmBuildRoad:
                return UIGameSpriteHandler.getRoadForPlayer(this.uiGameManager.gameController.myColor);
            default:
                logError('getBeginnerTipTexture', [
                    'Invalid suggested action',
                    suggestedAction
                ]);
                return PIXI.Texture.EMPTY;
        }
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.highlightViews = [];
        this.buttonScaleForMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? 1.25 : UIUtilsEjsVariables.isUserOnMobile ? 1.75 : 1;
        this.circlesScaleForMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? 1.4 : UIUtilsEjsVariables.isUserOnMobile ? 1.5 : 1;
        this.confirmActionController = new UIGameConfirmActionController(this.uiGameManager);
    }
}
